import React, { useEffect, useState } from 'react';
import { CalendarOutlined, UserOutlined, AppstoreOutlined, VideoCameraAddOutlined, HistoryOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import UserChip from './UserChip';
import { useNavigate, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const siderStyle = {
  height: '100vh',
  background: '#722ed1',  // Purple theme for events
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  zIndex: 1030,
};

function getItem(label, key, icon) {
  return { key, icon, label };
}

const EventSidebar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState('');

  useEffect(() => {
    const n = localStorage.getItem('name') || 'Event Staff';
    setName(n);
  }, []);

  const items = [
    getItem('My Profile', '/event', <UserOutlined />),
    getItem('My Event Shows', '/event/shows', <VideoCameraAddOutlined />),
    getItem('Completed Shows', '/event/completed-shows', <HistoryOutlined />),
    // Future items:
    // getItem('Event Bookings', '/event/bookings', <MoneyCollectOutlined />),
    // getItem('Snapshots', '/event/snapshots', <FileTextOutlined />),
  ];

  return (
    <Sider
      style={{
        ...siderStyle,
        width: collapsed ? 0 : 250,
        transition: 'width 0.2s',
      }}
      collapsed={collapsed}
      collapsedWidth={0}
      width={250}
    >
      <div
        style={{
          padding: '8px',
          background: '#722ed1',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <UserChip
          name={name}
          role="Event Staff"
          avatar=""
          handleCollapse={() => setCollapsed(!collapsed)}
        />
      </div>

      <div
        style={{
          height: 'calc(100vh - 80px)',
          overflowY: 'auto',
          background: '#722ed1',
        }}
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items}
          onClick={({ key }) => navigate(key)}
        />
      </div>
    </Sider>
  );
};

export default EventSidebar;

